/**
 * Product Thumbnail Gallery - Color-based image filtering
 * Handles filtering product images by color variant selection
 */
(function() {
  'use strict';
  
  // Prevent multiple initializations
  if (window.ProductThumbnailGalleryInitialized) return;
  window.ProductThumbnailGalleryInitialized = true;
  
  document.addEventListener('DOMContentLoaded', function () {
    try {
      var colorRadios = document.querySelectorAll('input[name="Farbe"]');
      if (!colorRadios || colorRadios.length === 0) {
        return;
      }
      
      // State
      var currentVisibleSlides = [];
      var currentVisibleIndex = 0;
      var globalSwiper = null;
      var isAnimating = false;
      var filteredLightbox = null;
      
      // Touch tracking
      var touchStartX = 0;
      var touchStartY = 0;
      var touchEndX = 0;
      var touchEndY = 0;
      var minSwipeDistance = 50;
    
    function isModelPhoto(mediaItem) {
      var src = mediaItem.getAttribute('data-src') || '';
      return src.toLowerCase().indexOf('model_p_') !== -1 || 
             src.toLowerCase().indexOf('model-p-') !== -1 ||
             src.toLowerCase().indexOf('/model_') !== -1;
    }
    
    function updatePaginationDisplay() {
      if (!globalSwiper || !globalSwiper.pagination || !globalSwiper.pagination.el) return;
      if (currentVisibleSlides.length === 0) return;
      
      var totalVisible = currentVisibleSlides.length;
      var displayIndex = currentVisibleIndex + 1;
      globalSwiper.pagination.el.textContent = displayIndex + ' / ' + totalVisible;
    }
    
    function slideIndexByMediaId(swiper, mediaId) {
      if (!swiper || !mediaId) return -1;
      var root = swiper.el || document;
      var slides = root.querySelectorAll('.swiper-slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('swiper-slide-duplicate')) continue;
        if (slides[i].getAttribute('data-media-id') === mediaId || slides[i].getAttribute('data-target') === mediaId) {
          return i;
        }
      }
      return -1;
    }

    function findThumbByMediaId(id) {
      return document.querySelector('.product__thumbs-item:not(.swiper-slide-duplicate)[data-media-id="' + id + '"]') ||
        document.querySelector('.product__thumbs-item:not(.swiper-slide-duplicate)[data-target="' + id + '"]');
    }

    function syncThumbs(mediaItem) {
      if (!mediaItem) return;

      var id = mediaItem.getAttribute('data-media-id');
      var thumb = findThumbByMediaId(id);

      document.querySelectorAll('.product__thumbs-item').forEach(function(item) {
        item.classList.toggle('swiper-slide-thumb-active', item === thumb);
      });
    }

    function navigateToSlide(visibleIndex, instant, force) {
      if (!force && isAnimating) return;
      if (!globalSwiper || visibleIndex < 0 || visibleIndex >= currentVisibleSlides.length) return;

      var target = currentVisibleSlides[visibleIndex];
      var mediaId = target.getAttribute('data-media-id');
      var swiperIndex = slideIndexByMediaId(globalSwiper, mediaId);
      if (swiperIndex < 0) swiperIndex = visibleIndex;
      
      isAnimating = true;
      currentVisibleIndex = visibleIndex;
      var gallery = document.querySelector('media-gallery');
      if (gallery && target.style) {
        var ratio = target.querySelector('.product__media-container');
        var ratioVal = ratio && (ratio.style.getPropertyValue('--aspect-ratio') || getComputedStyle(ratio).getPropertyValue('--aspect-ratio'));
        if (ratioVal) gallery.style.setProperty('--pdp-media-ratio', ratioVal.trim());
      }
      globalSwiper.slideTo(swiperIndex, 0, false);
      syncThumbs(target);
      updatePaginationDisplay();
      
      setTimeout(function() {
        isAnimating = false;
      }, 50);
    }

    function reorderVisibleFirst(wrapper, orderedVisible, allItems) {
      if (!wrapper) return;
      orderedVisible.forEach(function(el) {
        if (el) wrapper.appendChild(el);
      });
      allItems.forEach(function(el) {
        if (el && el.style.display === 'none') wrapper.appendChild(el);
      });
    }
    
    function goToNext() {
      if (currentVisibleSlides.length === 0) return;
      var nextIndex = (currentVisibleIndex + 1) % currentVisibleSlides.length;
      navigateToSlide(nextIndex);
    }
    
    function goToPrev() {
      if (currentVisibleSlides.length === 0) return;
      var prevIndex = (currentVisibleIndex - 1 + currentVisibleSlides.length) % currentVisibleSlides.length;
      navigateToSlide(prevIndex);
    }
    
    function handleTouchStart(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }
    
    function handleTouchMove(e) {
      touchEndX = e.touches[0].clientX;
      touchEndY = e.touches[0].clientY;
    }
    
    function handleTouchEnd(e) {
      var deltaX = touchEndX - touchStartX;
      var deltaY = touchEndY - touchStartY;
      
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
        if (deltaX < 0) {
          goToNext();
        } else {
          goToPrev();
        }
      }
      
      touchStartX = 0;
      touchStartY = 0;
      touchEndX = 0;
      touchEndY = 0;
    }
    
    function setupTouchHandlers(mediaGallery) {
      var galleryViewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
      if (!galleryViewer) return;
      
      galleryViewer.removeEventListener('touchstart', handleTouchStart);
      galleryViewer.removeEventListener('touchmove', handleTouchMove);
      galleryViewer.removeEventListener('touchend', handleTouchEnd);
      
      galleryViewer.addEventListener('touchstart', handleTouchStart, { passive: true });
      galleryViewer.addEventListener('touchmove', handleTouchMove, { passive: true });
      galleryViewer.addEventListener('touchend', handleTouchEnd, { passive: true });
    }
    
    function enableNavButton(btn) {
      if (!btn || !btn.parentNode) return null;
      var clone = btn.cloneNode(true);
      btn.parentNode.replaceChild(clone, btn);
      clone.classList.remove('swiper-button-disabled', 'swiper-button-lock');
      clone.removeAttribute('disabled');
      clone.setAttribute('aria-disabled', 'false');
      clone.style.pointerEvents = 'auto';
      return clone;
    }

    function setupButtonHandlers(mediaGallery) {
      var nextBtn = enableNavButton(mediaGallery.querySelector('.swiper-button-next'));
      var prevBtn = enableNavButton(mediaGallery.querySelector('.swiper-button-prev'));

      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          goToNext();
          nextBtn.blur();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          goToPrev();
          prevBtn.blur();
        });
      }
    }

    function setupThumbHandlers(mediaGallery) {
      var thumbsEl = mediaGallery.querySelector('[id^="GalleryThumbnails"]');
      if (!thumbsEl || thumbsEl.dataset.hakroThumbBound === 'true') return;
      thumbsEl.dataset.hakroThumbBound = 'true';

      var activateThumb = function(e) {
        var thumb = e.target.closest && e.target.closest('.product__thumbs-item');
        if (!thumb || thumb.style.display === 'none') return;

        var id = thumb.getAttribute('data-media-id') || thumb.getAttribute('data-target');
        if (!id) return;

        for (var i = 0; i < currentVisibleSlides.length; i++) {
          if (currentVisibleSlides[i].getAttribute('data-media-id') === id) {
            e.preventDefault();
            e.stopPropagation();
            navigateToSlide(i, false, true);
            return;
          }
        }
      };

      thumbsEl.addEventListener('pointerup', activateThumb, true);
      thumbsEl.addEventListener('click', activateThumb, true);
    }
    
    function initFilteredLightbox() {
      if (filteredLightbox) {
        filteredLightbox.destroy();
        filteredLightbox = null;
      }
      
      if (!window.FoxTheme || !window.FoxTheme.PhotoSwipeLightbox) {
        return;
      }
      
      var dataSource = [];
      currentVisibleSlides.forEach(function(media, index) {
        var mediaType = media.getAttribute('data-media-type');
        
        if (mediaType === 'image') {
          dataSource.push({
            id: index,
            src: media.getAttribute('data-src'),
            width: parseInt(media.getAttribute('data-pswp-width')) || 1946,
            height: parseInt(media.getAttribute('data-pswp-height')) || 1946,
            mediaType: mediaType,
          });
        }
      });
      
      if (dataSource.length === 0) return;
      
      filteredLightbox = new window.FoxTheme.PhotoSwipeLightbox({
        dataSource: dataSource,
        pswpModule: window.FoxTheme.PhotoSwipe,
        bgOpacity: 1,
        arrowPrev: false,
        arrowNext: false,
        zoom: false,
        close: false,
        counter: false,
        preloader: false,
      });
      
      filteredLightbox.on('uiRegister', function() {
        if (dataSource.length > 1) {
          filteredLightbox.pswp.ui.registerElement({
            name: 'next',
            ariaLabel: 'Next slide',
            order: 3,
            isButton: true,
            html: '<svg class="pswp-icon-next" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z" transform="translate(100, 100) rotate(180) "></path></svg>',
            onClick: function() {
              filteredLightbox.pswp.next();
            },
          });
          filteredLightbox.pswp.ui.registerElement({
            name: 'prev',
            ariaLabel: 'Previous slide',
            order: 1,
            isButton: true,
            html: '<svg class="pswp-icon-prev" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
            onClick: function() {
              filteredLightbox.pswp.prev();
            },
          });
        }
        filteredLightbox.pswp.ui.registerElement({
          name: 'close-zoom',
          ariaLabel: 'Close zoom image',
          order: 2,
          isButton: true,
          html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
          onClick: function() {
            filteredLightbox.pswp.close();
          },
        });
      });
      
      filteredLightbox.on('change', function() {
        var currIndex = filteredLightbox.pswp.currIndex;
        if (currIndex !== currentVisibleIndex) {
          navigateToSlide(currIndex, true);
        }
      });
      
      filteredLightbox.init();
    }
    
    function setupLightboxTriggers(mediaGallery) {
      var zoomButtons = mediaGallery.querySelectorAll('.js-photoswipe--zoom');
      zoomButtons.forEach(function(btn) {
        var newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        
        newBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          if (!filteredLightbox) return;
          
          var mediaItem = newBtn.closest('.product__media-item');
          if (!mediaItem) return;
          
          var mediaId = mediaItem.getAttribute('data-media-id');
          var visibleIndex = 0;
          
          for (var i = 0; i < currentVisibleSlides.length; i++) {
            if (currentVisibleSlides[i].getAttribute('data-media-id') === mediaId) {
              visibleIndex = i;
              break;
            }
          }
          
          filteredLightbox.loadAndOpen(visibleIndex);
        });
      });
    }
    
    function filterAndShowImages() {
      var selectedRadio = document.querySelector('input[name="Farbe"]:checked');
      if (!selectedRadio) return;
      
      var rawColorCode = selectedRadio.getAttribute('data-color-code') || '';
      var selectedColorCode = rawColorCode.replace(/[^a-zA-Z0-9\-_]/g, '').toLowerCase();
      
      if (!selectedColorCode) return;
      
      var mediaGalleryEl = document.querySelector('media-gallery');
      var layout = (mediaGalleryEl && mediaGalleryEl.dataset.mediaLayout) || '';
      var firstMediaFull = !mediaGalleryEl || mediaGalleryEl.dataset.firstMediaFull !== 'false';
      var isDesktopGridView = window.innerWidth >= 768 &&
        (layout === 'grid-mix' || layout === 'stacked' || layout === 'columns');
      var needsSlider = !isDesktopGridView;

      var mediaItems = document.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)');
      var visibleItems = [];
      var modelImage = null;
      var modelImageIndex = -1;
      
      mediaItems.forEach(function(mediaItem) {
        var mediaColorCode = (mediaItem.getAttribute('data-color') || '').toLowerCase();
        
        mediaItem.classList.remove('first-visible-slide');
        mediaItem.style.width = '';
        mediaItem.style.order = '';
        
        if (mediaColorCode === selectedColorCode) {
          mediaItem.style.display = '';
          
          if (isModelPhoto(mediaItem) && !modelImage) {
            modelImage = mediaItem;
            modelImageIndex = visibleItems.length;
          }
          
          visibleItems.push(mediaItem);
        } else {
          mediaItem.style.display = 'none';
        }
      });

      var thumbItems = document.querySelectorAll('.product__thumbs-item:not(.swiper-slide-duplicate)');
      thumbItems.forEach(function(thumb) {
        var thumbColor = (thumb.getAttribute('data-color') || '').toLowerCase();
        thumb.style.display = thumbColor === selectedColorCode ? '' : 'none';
      });
      document.querySelectorAll('.product__thumbs-item.swiper-slide-duplicate').forEach(function(dupThumb) {
        var dupId = dupThumb.getAttribute('data-media-id') || dupThumb.getAttribute('data-target');
        var originalThumb = document.querySelector('.product__thumbs-item:not(.swiper-slide-duplicate)[data-media-id="' + dupId + '"]') ||
          document.querySelector('.product__thumbs-item:not(.swiper-slide-duplicate)[data-target="' + dupId + '"]');
        if (originalThumb) {
          dupThumb.style.display = originalThumb.style.display;
        }
      });
      
      if (visibleItems.length > 0) {
        if (modelImage && modelImageIndex > 0) {
          visibleItems.splice(modelImageIndex, 1);
          visibleItems.unshift(modelImage);
          modelImageIndex = 0;
        }
        
        visibleItems.forEach(function(item, index) {
          if (isDesktopGridView) {
            item.style.order = index;

            if (layout === 'columns') {
              if (index === 0) item.classList.add('first-visible-slide');
              item.style.width = index === 0 && firstMediaFull ? '100%' : '';
            } else if (layout === 'stacked' || index === 0) {
              if (index === 0) item.classList.add('first-visible-slide');
              item.style.width = '100%';
            } else {
              item.style.width = '50%';
            }
          } else {
            item.style.width = '';
            item.style.order = '';
          }
        });
      }
      
      if (isDesktopGridView) {
        mediaItems.forEach(function(mediaItem) {
          if (mediaItem.style.display === 'none') {
            mediaItem.style.order = 9999;
          }
        });
      }
      
      var duplicateSlides = document.querySelectorAll('.product__media-item.swiper-slide-duplicate');
      duplicateSlides.forEach(function(dupSlide) {
        var dupMediaId = dupSlide.getAttribute('data-media-id');
        var originalSlide = document.querySelector('.product__media-item:not(.swiper-slide-duplicate)[data-media-id="' + dupMediaId + '"]');
        if (originalSlide) {
          dupSlide.style.display = originalSlide.style.display;
          dupSlide.style.order = originalSlide.style.order;
          dupSlide.style.width = originalSlide.style.width;
        }
      });
      
      if (needsSlider && visibleItems.length > 0) {
        var mediaWrap = document.querySelector('.product__media-list');
        reorderVisibleFirst(mediaWrap, visibleItems, mediaItems);

        var thumbsWrap = document.querySelector('.thumbnail-list');
        if (thumbsWrap) {
          var orderedThumbs = visibleItems.map(function(item) {
            return findThumbByMediaId(item.getAttribute('data-media-id'));
          }).filter(Boolean);
          reorderVisibleFirst(thumbsWrap, orderedThumbs, thumbItems);
        }
      }

      currentVisibleSlides = visibleItems;
      currentVisibleIndex = 0;
      
      function applySwiperLogic(attempt) {
        var mediaGallery = document.querySelector('media-gallery');

        if (!needsSlider) {
          initFilteredLightbox();
          if (mediaGallery) setupLightboxTriggers(mediaGallery);
          return;
        }

        var sliderReady = mediaGallery && mediaGallery.sliderInstance && mediaGallery.sliderInstance.slider;
        if (!sliderReady) {
          if ((attempt || 0) < 20) {
            setTimeout(function() { applySwiperLogic((attempt || 0) + 1); }, 100);
          } else {
            initFilteredLightbox();
            if (mediaGallery) setupLightboxTriggers(mediaGallery);
          }
          return;
        }
        
        globalSwiper = mediaGallery.sliderInstance.slider;

        if (globalSwiper.params) {
          globalSwiper.params.loop = false;
          globalSwiper.params.speed = 0;
        }
        globalSwiper.allowTouchMove = false;
        globalSwiper.allowSlideNext = true;
        globalSwiper.allowSlidePrev = true;
        
        globalSwiper.update();

        if (mediaGallery.thumbsInstance && mediaGallery.thumbsInstance.slider) {
          var thumbsSwiper = mediaGallery.thumbsInstance.slider;
          thumbsSwiper.params.preventClicks = false;
          thumbsSwiper.params.preventClicksPropagation = false;
          thumbsSwiper.params.slideToClickedSlide = false;
          thumbsSwiper.params.freeMode = false;
          thumbsSwiper.allowTouchMove = false;
          thumbsSwiper.update();
          if (typeof thumbsSwiper.setTranslate === 'function') {
            thumbsSwiper.setTranslate(0);
          }
        }
        
        setupTouchHandlers(mediaGallery);
        setupButtonHandlers(mediaGallery);
        setupThumbHandlers(mediaGallery);
        
        initFilteredLightbox();
        setupLightboxTriggers(mediaGallery);
        
        navigateToSlide(currentVisibleIndex, true);
      }
      
      applySwiperLogic(0);
    }
    
    colorRadios.forEach(function(radio) {
      radio.addEventListener('change', filterAndShowImages);
    });
    
    filterAndShowImages();
    
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (globalSwiper) {
          globalSwiper.update();
          navigateToSlide(currentVisibleIndex, true);
        }
      }, 150);
    });
    
    } catch (e) {
      // Fail silently
    }
  });
})();
